import { FC } from 'react'
import { Table, Button, Popconfirm,Image } from 'antd'
import { QueryListResponse } from '../../../../API/priceComparison'
import {pageSize} from '../../'
export interface PageInfo {
  currentPage: number
  total: number
}

interface ListProps {
  loading:boolean
  data: QueryListResponse[]
  pageInfo: PageInfo
  onChangeState: (id:string, state:string) => void
  onPageChange: (currentPage: number) => void
  onChangeTargetedPrice: (id:string) => void
}

const List: FC<ListProps> = ({
  data,
  onChangeState,
  loading,
  pageInfo,
  onPageChange,
  onChangeTargetedPrice,
}) => {
  const columns = [
    {
      title: 'Product ID',
      dataIndex: 'productId',
      key: 'productId',
      align: 'center',
    },
    {
      title: 'Product Image',
      dataIndex: 'images',
      key: 'productImage',
      align: 'center',
      render: images => {
        return <Image src={images?.[0]?.thumbnail?.url} width={50} />
      },
    },
    {
      title: 'Product Name',
      dataIndex: 'productName',
      key: 'productName',
      align: 'center',
    },
    {
      title: 'Targeted Price',
      dataIndex: 'targetPrice',
      key: 'targetedPrice',
      align: 'center',
      render: (targetPrice, row) => {
        return (
          <div
            style={{ cursor: 'pointer', userSelect: 'none' }}
            onClick={() => onChangeTargetedPrice(row.productId)}
          >
            {targetPrice}
          </div>
        )
      },
    },
    {
      title: 'State',
      dataIndex: 'state',
      key: 'state',
      render: (state, row) => (
        <Popconfirm
          title={state === 'OFF' ? ' 确认开启?' : ' 确认关闭?'}
          okText="确认"
          cancelText="取消"
          onConfirm={() => onChangeState(row.productId, state === 'OFF' ? 'ON' : 'OFF')}
        >
          <Button type="primary" size="small" danger={state === 'OFF'}>
            {state}
          </Button>
        </Popconfirm>
      ),
      align: 'center',
    },
  ]
  return (
    <Table
      columns={columns as any}
      size="small"
      dataSource={data}
      bordered
      rowKey="productId"
      loading={loading}
      pagination={{
        total: pageInfo.total,
        current: pageInfo.currentPage,
        defaultPageSize: pageSize,
        showSizeChanger: false,
        onChange: onPageChange,
      }}
    />
  )
}

export default List